/* HANNA LED Face Mask PRO – CRO-Test (Blueprint v1.1)
   1) Variantengetreuer Hero (Ueberblendung, kein Springen der Galerie)
   2) Preis pro Anwendung je Variante
   3) Zaehler in der Galerie
   4) Sticky-Kaufleiste: loest nur den echten Kaufbutton aus (Kaching bleibt einzige Logik)
   5) Tracking-Ereignisse ueber Shopify.analytics.publish */
(function () {
  'use strict';

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        var payload = data || {};
        payload.theme_id = Shopify.theme && Shopify.theme.id;
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }
  window.hhTrack = track;

  var dataEl = document.querySelector('[data-hh-led-data]');
  var cfg = {};
  try { cfg = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) {}
  var names = cfg.names || {};

  function getForm() {
    return document.querySelector('.product-form__buy-buttons form[action*="/cart/add"]');
  }
  function getBlock() { return document.querySelector('kaching-bundles-block'); }
  function kachingReady(form) {
    return !!(form && form.querySelector('[name="properties[__kaching_bundles]"]'));
  }
  function currentId(form) {
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  /* ---------- 1) Hero + 2) Preis pro Anwendung ---------- */
  /* Varianten-Slots (14.10.): Slides mit data-hh-only-variant nur fuer die passende Variante zeigen */
  var hhSlots = null, hhWant = null;
  function hhSlotInit(car) {
    if (hhSlots) return;
    var all = [].slice.call(car.querySelectorAll('.product__media-item'));
    hhSlots = all.filter(function (el) { return el.hasAttribute('data-hh-only-variant'); }).map(function (el) {
      return { el: el, ids: el.getAttribute('data-hh-only-variant').split(/\s+/), thumb: document.querySelector('.hh-led-media [data-action="select"][aria-controls="' + el.id + '"]') };
    });
    hhSlots.order = all;
  }
  function syncVariantSlides(id) {
    var car = document.querySelector('.hh-led-media .product__media-list');
    if (!car) return;
    hhSlotInit(car);
    if (!hhSlots.length) return;
    hhWant = String(id);
    var wants = function (o) { return o.ids.indexOf(hhWant) > -1; };
    /* Galerie noch ohne Flickity (z. B. vor dem ersten Sichtbarwerden): direkt im DOM umsortieren */
    if (!car.classList.contains('flickity-enabled')) {
      hhSlots.forEach(function (o) {
        var w = wants(o), inside = o.el.isConnected;
        if (!w && inside) { o.el.remove(); }
        else if (w && !inside) {
          var all = hhSlots.order, nx = null, k;
          for (k = all.indexOf(o.el) + 1; k < all.length; k++) { if (all[k].isConnected) { nx = all[k]; break; } }
          if (nx) nx.parentNode.insertBefore(o.el, nx); else car.appendChild(o.el);
        }
        if (o.thumb) o.thumb.hidden = !w;
      });
    }
    if (!('flickityInstance' in car)) return;
    Promise.resolve(car.flickityInstance).then(function (flk) {
      if (!flk || !flk.cells) return;
      var changed = false;
      var has = function (el) { return flk.cells.some(function (c) { return c.element === el; }); };
      hhSlots.forEach(function (o) {
        var w = wants(o), inside = has(o.el);
        if (!w && inside) {
          if (flk.selectedElement === o.el) flk.select(0, false, true);
          flk.remove(o.el); changed = true;
        } else if (w && !inside) {
          var all = hhSlots.order, at = 0, k;
          for (k = 0; k < all.indexOf(o.el); k++) { if (has(all[k])) at++; }
          flk.insert(o.el, at); changed = true;
        }
        if (o.thumb) o.thumb.hidden = !w;
      });
      if (changed) { flk.resize(); flk.select(Math.min(flk.selectedIndex, flk.cells.length - 1), false, true); }
    });
  }
  function applyVariant() {
    var form = getForm();
    if (!kachingReady(form)) return;
    var id = currentId(form);
    /* Hero und Varianten-Slots (14.10.): passendes Bild je Variante einblenden */
    var heroes = document.querySelectorAll('[data-hh-hero]');
    var anyHero = false;
    heroes.forEach(function (hero) {
      if (!hero.querySelector('[data-hh-variant="' + id + '"]')) return;
      anyHero = true;
      hero.querySelectorAll('[data-hh-variant]').forEach(function (img) {
        var on = img.getAttribute('data-hh-variant') === id;
        if (on && img.getAttribute('loading') === 'lazy' && hero.closest('[data-media-id="hh-hero"]')) img.setAttribute('loading', 'eager');
        img.classList.toggle('is-active', on);
      });
    });
    if (anyHero) {
      document.querySelectorAll('[data-hh-thumb-variant]').forEach(function (img) {
        img.hidden = img.getAttribute('data-hh-thumb-variant') !== id;
      });
    }
    syncVariantSlides(id);
    var ppa = document.querySelectorAll('[data-hh-ppa]');
    if (ppa.length && document.querySelector('[data-hh-ppa="' + id + '"]')) {
      ppa.forEach(function (el) { el.hidden = el.getAttribute('data-hh-ppa') !== id; });
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[name^="kaching-bundles-deal-"]')) {
      setTimeout(applyVariant, 0);
      setTimeout(applyVariant, 120);
      setTimeout(function () {
        applyVariant();
        track('hh_variant_selected', { variant_id: currentId(getForm()), bar: t.value });
      }, 400);
    }
  });

  function whenKachingReady(cb) {
    var form = getForm();
    if (kachingReady(form)) { cb(); return; }
    var tries = 0;
    var mo = new MutationObserver(function () {
      if (kachingReady(getForm())) { mo.disconnect(); clearInterval(iv); requestAnimationFrame(cb); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    var iv = setInterval(function () {
      tries++;
      if (kachingReady(getForm())) { clearInterval(iv); mo.disconnect(); cb(); }
      else if (tries > 40) { clearInterval(iv); mo.disconnect(); }
    }, 250);
  }
  window.addEventListener('pageshow', function () { applyVariant(); });

  /* ---------- 3) Galerie-Zaehler ---------- */
  function initCounter() {
    var list = document.querySelector('.hh-led-media .product__media-list');
    var counter = document.querySelector('[data-hh-counter]');
    if (!list || !counter) return;
    var update = function () {
      var items = list.querySelectorAll('.product__media-item:not(.is-filtered)');
      var idx = 0;
      items.forEach(function (it, i) { if (it.classList.contains('is-selected')) idx = i; });
      if (items.length > 1) counter.textContent = (idx + 1) + ' / ' + items.length;
      var cur = items[idx];
      if (cur && cur.getAttribute('data-hh-seen') !== '1') {
        cur.setAttribute('data-hh-seen', '1');
        if (idx > 0) track('hh_gallery_slide', { slide: idx + 1 });
      }
    };
    new MutationObserver(update).observe(list, { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] });
    update();
    var vid = list.querySelector('[data-media-id="hh-video"]');
    if (vid) vid.addEventListener('click', function () { track('hh_video_play', { slide: 'video' }); }, { once: true });
  }

  /* ---------- 4) Sticky-Kaufleiste ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-hh-sticky]');
    var form = getForm();
    var btn = form && form.querySelector('[type="submit"]');
    var block = getBlock();
    if (!bar || !form || !btn || !block) return;
    var q = function (s) { return bar.querySelector(s); };
    var state = { above: false, drawer: false, kbd: false, popup: false, valid: false };
    var hooked = false;

    function render() {
      var show = state.above && !state.drawer && !state.kbd && !state.popup && state.valid;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.documentElement.classList.toggle('hh-sticky-on', show);
      if (show && !bar.getAttribute('data-viewed')) {
        bar.setAttribute('data-viewed', '1');
        track('hh_sticky_view', { variant_id: currentId(form) });
      }
    }

    function sync() {
      var id = currentId(form);
      var amounts = (btn.textContent || '').match(/\d{1,3}(?:\.\d{3})*,\d{2}/g) || [];
      var price = amounts[amounts.length - 1];
      state.valid = !!(names[id] && price);
      if (state.valid) {
        q('[data-hh-sticky-line]').textContent = names[id];
        q('[data-hh-sticky-price]').textContent = price + ' €';
        var checked = block.querySelector('input[name^="kaching-bundles-deal-"]:checked');
        var dealBar = checked && checked.closest('.kaching-bundles__bar');
        var gift = dealBar && dealBar.querySelector('.kaching-bundles__free-gift');
        q('[data-hh-sticky-gift]').hidden = !gift;
        bar.querySelectorAll('[data-hh-sv]').forEach(function (i) { i.hidden = i.getAttribute('data-hh-sv') !== id; });
      }
      render();
    }

    function measureAbove() {
      var a = block.getBoundingClientRect().bottom < 0 && btn.getBoundingClientRect().bottom < 0;
      if (a !== state.above) { state.above = a; render(); }
    }
    var io = new IntersectionObserver(measureAbove);
    io.observe(block);
    io.observe(btn);
    window.addEventListener('scroll', measureAbove, { passive: true });

    function chain(name, fn) {
      var prev = window[name];
      window[name] = function () {
        try { if (typeof prev === 'function') prev.apply(this, arguments); } finally { fn.apply(this, arguments); }
      };
    }
    chain('upcartOnCartOpened', function () { hooked = true; state.drawer = true; render(); });
    chain('upcartOnCartClosed', function () { hooked = true; state.drawer = false; render(); });
    chain('upcartOnAddToCart', function () {
      if (bar.hasAttribute('data-busy')) track('hh_sticky_result', { result: 'ok' });
      bar.removeAttribute('data-busy');
    });
    var drawer = document.getElementById('CartPopup');
    function measureDrawer() {
      if (hooked || !drawer) return;
      setTimeout(function () {
        var r = drawer.getBoundingClientRect();
        state.drawer = r.width > 0 && r.left < window.innerWidth - 1;
        render();
      }, 400);
    }
    if (drawer) new MutationObserver(measureDrawer).observe(drawer, { attributes: true, attributeFilter: ['class', 'style'] });
    var chp = document.querySelector('.chp_pp_discount_overlay');
    if (chp) new MutationObserver(function () {
      var r = chp.getBoundingClientRect();
      state.popup = r.width > 0 && r.height > 0; render();
    }).observe(chp, { attributes: true, attributeFilter: ['class', 'style'] });

    document.addEventListener('focusin', function (e) {
      if (e.target.matches && e.target.matches('input:not([type=radio]):not([type=checkbox]):not([type=hidden]), textarea, select')) { state.kbd = true; render(); }
    });
    document.addEventListener('focusout', function () { if (state.kbd) { state.kbd = false; render(); } });

    q('[data-hh-sticky-buy]').addEventListener('click', function () {
      if (bar.hasAttribute('data-busy') || btn.disabled) return;
      bar.setAttribute('data-busy', '1');
      track('hh_sticky_click', { variant_id: currentId(form) });
      btn.click();
      setTimeout(function () {
        if (bar.hasAttribute('data-busy')) track('hh_sticky_result', { result: 'timeout' });
        bar.removeAttribute('data-busy');
      }, 4000);
    });
    q('[data-hh-sticky-change]').addEventListener('click', function () {
      var top = block.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    block.addEventListener('change', function () { setTimeout(sync, 0); setTimeout(sync, 400); });
    new MutationObserver(sync).observe(btn, { childList: true, characterData: true, subtree: true });
    sync();
    measureAbove();
  }

  /* ---------- Vergleichsabschnitt: Variante waehlen ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hh-pick]');
    if (!a) return;
    e.preventDefault();
    var radio = document.querySelector('input[name^="kaching-bundles-deal-"][value="' + a.getAttribute('data-hh-pick') + '"]');
    if (radio && !radio.checked) radio.click();
    var block = getBlock();
    if (block) {
      var top = block.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    track('hh_compare_pick', { bar: a.getAttribute('data-hh-pick') });
  });

  function watchButton() {
    var form = getForm();
    var btn = form && form.querySelector('[type="submit"]');
    if (btn) new MutationObserver(function () { applyVariant(); }).observe(btn, { childList: true, characterData: true, subtree: true });
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput) new MutationObserver(function () { applyVariant(); }).observe(idInput, { attributes: true });
  }

  function init() {
    initCounter();
    whenKachingReady(function () { applyVariant(); watchButton(); initSticky(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
